import React from 'react';
import { Route, Redirect } from "react-router-dom";
import { config } from "./constants/domainConfig";


const PrivateRoute = ({ component: Component, ...rest }) => {
    let isLoggedIn = false;

    if (sessionStorage.getItem('authorized')) {
        let loginData= JSON.parse(sessionStorage.getItem('authorized'));
        if(loginData.success){
            isLoggedIn=true
        }
    }
    return (
        <Route
            {...rest}
            render={props =>
                (config.subDomain == "za.fun-box" && window.location.href.indexOf('terms-conditions') >= 0) ? (
                    <Component {...props} />
                ) : 
                isLoggedIn === true ? (
                    <Component {...props} />
                ) : (
                        <Redirect to={{ pathname: '/login' }} />
                    )
            }
        />)
};
export default PrivateRoute;



// WEBPACK FOOTER //
// ./src/PrivateRoute.js